import React, { useEffect, useRef, useState } from 'react';

export default function Skills() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  const skills = [
    { name: 'Microsoft 365', icon: 'fab fa-microsoft', color: '#D83B01' },
    { name: 'HTML', icon: 'fab fa-html5', color: '#E34F26' },
    { name: 'CSS', icon: 'fab fa-css3-alt', color: '#1572B6' },
    { name: 'JavaScript', icon: 'fab fa-js', color: '#F7DF1E' },
    { name: 'Bootstrap', icon: 'fab fa-bootstrap', color: '#7952B3' },
    { name: 'Tailwind CSS', icon: 'fas fa-wind', color: '#06B6D4' },
    { name: 'React', icon: 'fab fa-react', color: '#61DAFB' },
    { name: 'Python', icon: 'fab fa-python', color: '#3776AB' },
    { name: 'Django', icon: 'fas fa-server', color: '#092E20' },
    { name: 'Flask', icon: 'fas fa-flask', color: '#000000' },
    { name: 'SQL', icon: 'fas fa-database', color: '#4479A1' },
    { name: 'Git', icon: 'fab fa-git-alt', color: '#F05032' },
    { name: 'Tkinter', icon: 'fas fa-window-maximize', color: '#FFD43B' },
    { name: 'Canva', icon: 'fas fa-palette', color: '#00C4CC' },
    { name: 'Figma', icon: 'fab fa-figma', color: '#F24E1E' },
    { name: 'Photoshop', icon: 'fas fa-image', color: '#31A8FF' },
    { name: 'VS Code', icon: 'fas fa-code', color: '#007ACC' }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section id="skills" className="skills-section" ref={sectionRef}>
      <div className="container">
        <h2 className="section-title">Skills & Technologies</h2>
        <div className={`skills-grid ${isVisible ? 'visible' : ''}`}>
          {skills.map((skill, index) => (
            <div
              className="skill-card"
              key={index}
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <div className="skill-icon" style={{ color: skill.color }}>
                <i className={skill.icon}></i>
              </div>
              <h4>{skill.name}</h4>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
